import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import {authHeader} from '../../utils/headers';

const API_BASE = import.meta.env.VITE_APIURL || '';

export const conteneurConsignesApi = createApi({
    reducerPath: 'conteneurConsignesApi',
    baseQuery: fetchBaseQuery({
        baseUrl: API_BASE,
        prepareHeaders: (headers) => {
            const token = authHeader();
            if (typeof token === 'string' && token) {
                headers.set('authorization', token);
            }
            headers.set('Accept', 'application/ld+json');
            return headers;
        },
    }),
    tagTypes: ['ConteneurConsigne'],
    endpoints: (builder) => ({
        // Affectations d'un conteneur (SearchFilter exact sur `conteneur`).
        getByConteneur: builder.query({
            query: (conteneurIri) => `/conteneur_consignes?conteneur=${encodeURIComponent(conteneurIri)}`,
            transformResponse: (r) => r?.['hydra:member'] ?? (Array.isArray(r) ? r : []),
            providesTags: (result, error, conteneurIri) => [{type: 'ConteneurConsigne', id: conteneurIri}],
        }),
        createConteneurConsigne: builder.mutation({
            query: ({conteneurIri, ...body}) => ({
                url: '/conteneur_consignes',
                method: 'POST',
                headers: {'Content-Type': 'application/ld+json'},
                body: JSON.stringify(body),
            }),
            invalidatesTags: (result, error, {conteneurIri}) => [{type: 'ConteneurConsigne', id: conteneurIri}],
        }),
        deleteConteneurConsigne: builder.mutation({
            query: ({id}) => ({url: `/conteneur_consignes/${id}`, method: 'DELETE'}),
            invalidatesTags: (result, error, {conteneurIri}) => [{type: 'ConteneurConsigne', id: conteneurIri}],
        }),
    }),
});

export const {
    useGetByConteneurQuery,
    useCreateConteneurConsigneMutation,
    useDeleteConteneurConsigneMutation,
} = conteneurConsignesApi;
